import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  LinkButton,
  Modal,
  ModalTrigger,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { t } from "i18next";

export function ReviewerLearnMore() {
  return (
    <ModalTrigger
      trigger={
        <LinkButton
          style={{ marginLeft: "auto" }}
          testID="what-is-this-reviewer-button"
        >
          {t("What's this?")}
        </LinkButton>
      }
    >
      <Modal>
        <Dialog width="456px">
          {({ close }) => (
            <>
              <DialogHeader onClose={close}>
                {t("Assigning a reviewer")}
              </DialogHeader>
              <DialogContent>
                <div className={styles.body}>
                  <Text style="global/body-primary">
                    {t(
                      "A reviewer is responsible for reviewing completed background checks and making the final decision."
                    )}
                  </Text>
                  <Text style="global/body-primary">
                    {t(
                      "Requestors cannot access reports, scores, or detailed results. Instead, the assigned reviewer reviews the report and determines the outcome (for example, meets or does not meet criteria)."
                    )}
                  </Text>
                  <Text style="global/body-primary">
                    {t(
                      "Each Requestor must have a reviewer assigned. Reviewers must have Admin or Manager permissions."
                    )}
                  </Text>
                </div>
              </DialogContent>
              <DialogFooter>
                <PrimaryButton onPress={close} size="medium">
                  {t("Okay")}
                </PrimaryButton>
              </DialogFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </ModalTrigger>
  );
}

const styles = {
  body: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-3)",
  }),
};
